/**
 * Adzuki. My Settings - Specialties panel
 *
 * SET-18, with SET-77 (the two caps and the auto-feature) and SET-78 (the draggable list).
 *
 * TWO CONTROLS DESCRIBING ONE SELECTION. The four pickers say WHICH specialties; the list below
 * says in what order and which three are featured. Only the list writes, into three parallel
 * hidden arrays that AgentsEditForm::_syncAdvisorSpecialties() turns into rows - so every path
 * that changes the selection has to go through here, and removing a row has to reach back up
 * and deselect the option or the two descriptions disagree.
 *
 * ITS HOOKS ARE NOT THE LEGACY SCREEN'S. /Agents/edit renders the same four pickers as
 * .advisor-specialty-select and AgentsEditForm.js binds that class to a table with a priority
 * <select> per row. This panel's markup is my-settings- prefixed throughout, so neither
 * implementation can reach the other - the same separation SET-55 drew for shortcuts.
 *
 * DRAGULA IS ALREADY LOADED, concatenated into vendor.min.js with its css in vendor.min.css,
 * both of which the My Settings layout loads. Verified for SET-55 rather than assumed.
 */

(function MySettingsSpecialties($, Adzuki)
{
	"use strict";

	var MAX_SPECIALTIES = 15,
	    MAX_FEATURED    = 3,
	    CATEGORIES      = {
		    destination_specialties: {
			    slug : 'destination',
			    label: 'Destination',
			    badge: 'destination'
		    },
		    trip_type_specialties: {
			    slug : 'trip_type',
			    label: 'Trip Type',
			    badge: 'trip-type'
		    },
		    brand_specialties: {
			    slug : 'brand',
			    label: 'Brand',
			    badge: 'brand'
		    },
		    interest_style_specialties: {
			    slug : 'interest_style',
			    label: 'Interest/Style',
			    badge: 'interest-style'
		    }
	    },
	    _drake = null,
	    // THE ORDER LIVES HERE, not in the pickers. A <select multiple> reports its options in
	    // document order however they were chosen, so the advisor's priority would be lost the
	    // moment anything re-read them.
	    _state = [],
	    _seeded = false,
	    _list,
	    _escape,
	    _panel,
	    _categoryFor,
	    _seed,
	    _collect,
	    _render,
	    _writeFields,
	    _enforceSelectCap,
	    _markDirty,
	    _initDrag,
	    _reorderFromDom,
	    _refresh;

	/**
	 * The specialties list in the open panel, or an empty set when this pane is not rendered.
	 */
	_list = function list()
	{
		return $('.my-settings-overlay [data-my-settings-specialty-list]');
	};

	_panel = function panel()
	{
		return $('.my-settings-overlay form[data-form-component]');
	};

	/**
	 * Text as text. Every value in a row comes from the database and is written into markup.
	 */
	_escape = function escape(value)
	{
		return $('<div/>').text(value === null || value === undefined ? '' : value).html();
	};

	/**
	 * Which of the four categories a picker belongs to, read off the posted name.
	 */
	_categoryFor = function categoryFor($select)
	{
		var name  = $select.attr('name') || '',
		    match = null;

		$.each(CATEGORIES, function eachCategory(key) {
			if (name.indexOf('[' + key + ']') !== -1) {
				match = key;

				return false;
			}

			return true;
		});

		return match;
	};

	/**
	 * Restores the saved order and featured flags from the row data the pane printed.
	 *
	 * ORDER AND FEATURED CANNOT BE READ FROM THE PICKERS. They live in agent_advisor_specialties
	 * and the pickers carry only membership, so without this the advisor's priority resets to
	 * document order on every panel open.
	 */
	_seed = function seed()
	{
		var raw = $('.my-settings-overlay [data-my-settings-specialty-saved]').text(),
		    rows;

		_state  = [];
		_seeded = true;

		if (!$.trim(raw)) {
			return;
		}

		try {
			rows = JSON.parse(raw);
		} catch (e) {
			return;
		}

		if (!$.isArray(rows)) {
			return;
		}

		rows.sort(function bySavedPriority(a, b) {
			return (parseInt(a.priority, 10) || 0) - (parseInt(b.priority, 10) || 0);
		});

		$.each(rows, function eachRow(i, row) {
			_state.push({
				slug    : row.category_name,
				value   : row.option_name,
				text    : row.option_name,
				featured: parseInt(row.featured, 10) === 1
			});
		});
	};

	/**
	 * Reconciles the ordered state with what the pickers currently hold.
	 *
	 * Kept entries keep their position and their featured flag; anything newly selected joins
	 * the end, which is where an advisor expects a thing they just added; anything deselected
	 * falls out.
	 */
	_collect = function collect()
	{
		var present = {},
		    ordered = [];

		$('.my-settings-overlay .my-settings-specialty-select').each(function eachSelect() {
			var $select = $(this),
			    key     = _categoryFor($select),
			    info;

			if (!key) {
				return;
			}

			info = CATEGORIES[key];

			$select.find('option:selected').each(function eachOption() {
				var $option = $(this);

				present[info.slug + '|' + $option.val()] = {
					slug    : info.slug,
					label   : info.label,
					badge   : info.badge,
					value   : $option.val(),
					text    : $option.text(),
					featured: false
				};
			});
		});

		// kept, in the order the advisor put them
		$.each(_state, function eachKnown(i, item) {
			var key   = item.slug + '|' + item.value,
			    fresh = present[key];

			if (!fresh) {
				return;
			}

			fresh.featured = item.featured;

			ordered.push(fresh);

			delete present[key];
		});

		// and whatever is new, at the end
		$.each(present, function eachNew(key, item) {
			ordered.push(item);
		});

		_state = ordered;

		return _state;
	};

	/**
	 * The three parallel arrays the save reads. Nothing else on this pane posts.
	 */
	_writeFields = function writeFields()
	{
		var $fields = $('.my-settings-overlay [data-my-settings-specialty-fields]'),
		    prefix  = 'form_component_data[' + (_panel().attr('name') || 'AgentsEdit') + ']',
		    html    = '';

		$.each(_state, function eachItem(i, item) {
			html += '<input type="hidden" name="' + prefix + '[specialty_items][]" value="'
				+ _escape(item.slug + '|' + item.value) + '">';
			html += '<input type="hidden" name="' + prefix + '[specialty_priority][]" value="'
				+ (i + 1) + '">';
			html += '<input type="hidden" name="' + prefix + '[specialty_featured][]" value="'
				+ (item.featured ? '1' : '0') + '">';
		});

		$fields.html(html);
	};

	/**
	 * SET-77: at fifteen, every unselected option in every picker is disabled.
	 *
	 * ON THE OPTIONS RATHER THAN THE SELECT, so the advisor can still open a picker and see what
	 * they have chosen - and still deselect one, which is the only way back under the cap.
	 */
	_enforceSelectCap = function enforceSelectCap()
	{
		var full = _state.length >= MAX_SPECIALTIES;

		$('.my-settings-overlay .my-settings-specialty-select').each(function eachSelect() {
			var $select = $(this);

			$select.find('option').each(function eachOption() {
				var $option = $(this);

				$option.prop('disabled', full && !$option.prop('selected'));
			});

			if ($.fn.selectpicker) {
				$select.selectpicker('refresh');
			}
		});
	};

	/**
	 * Tells the save module the form changed.
	 *
	 * A DRAG AND A FEATURE TOGGLE FIRE NOTHING ON THEIR OWN. The dirty tracker listens for
	 * change/input on the inputs that post, and these two rewrite hidden inputs by script - so
	 * without this the advisor could reorder their specialties and find Save still disabled.
	 * Removing and adding are already covered, because both move a real <select>.
	 */
	_markDirty = function markDirty()
	{
		if (Adzuki.MySettings && Adzuki.MySettings.Save
			&& typeof Adzuki.MySettings.Save.recompute === 'function') {
			Adzuki.MySettings.Save.recompute();
		}
	};

	/**
	 * Draws the list, the counters and the caps from the current state.
	 */
	_render = function render()
	{
		var $list     = _list(),
		    $empty    = $('.my-settings-overlay [data-my-settings-specialty-empty]'),
		    featured  = 0,
		    html      = '';

		if (!$list.length) {
			return;
		}

		_collect();

		$.each(_state, function countFeatured(i, item) {
			if (item.featured) {
				featured++;
			}
		});

		// SET-77: the featured cap can only be exceeded by data, never by the ui - but if it is,
		// the buttons still have to let the advisor back under it
		$.each(_state, function buildRow(i, item) {
			var locked = !item.featured && featured >= MAX_FEATURED;

			html += '<li class="my-settings-specialty" data-slug="' + _escape(item.slug) + '"'
				+ ' data-value="' + _escape(item.value) + '">'
				+ '<span class="my-settings-specialty-grip" aria-hidden="true"></span>'
				+ '<span class="my-settings-specialty-seq">' + (i + 1) + '</span>'
				+ '<span class="my-settings-specialty-badge my-settings-specialty-badge-'
				+ _escape(item.badge) + '">' + _escape(item.label) + '</span>'
				+ '<span class="my-settings-specialty-name">' + _escape(item.text) + '</span>'
				+ '<button type="button" class="my-settings-specialty-feature'
				+ (item.featured ? ' is-featured' : '') + '"'
				+ (locked ? ' disabled' : '')
				+ ' aria-pressed="' + (item.featured ? 'true' : 'false') + '">'
				+ '<span class="my-settings-specialty-star" aria-hidden="true"></span>'
				+ (item.featured ? 'Featured' : 'Feature')
				+ '</button>'
				+ '<button type="button" class="my-settings-specialty-remove"'
				+ ' aria-label="Remove ' + _escape(item.text) + '"></button>'
				+ '</li>';
		});

		$list.html(html);
		$list.prop('hidden', _state.length === 0);
		$empty.prop('hidden', _state.length > 0);

		$('.my-settings-overlay [data-my-settings-specialty-total]').text(_state.length);
		$('.my-settings-overlay [data-my-settings-featured-total]').text(featured);

		_writeFields();
		_enforceSelectCap();
		_initDrag();
	};

	/**
	 * Re-reads the order from the dom after a drop.
	 */
	_reorderFromDom = function reorderFromDom()
	{
		var ordered = [];

		_list().children('.my-settings-specialty').each(function eachRow() {
			var $row  = $(this),
			    slug  = $row.attr('data-slug'),
			    value = $row.attr('data-value');

			$.each(_state, function findItem(i, item) {
				if (item.slug === slug && item.value === value) {
					ordered.push(item);

					return false;
				}

				return true;
			});
		});

		if (ordered.length === _state.length) {
			_state = ordered;
		}
	};

	/**
	 * SET-78: drag to set priority.
	 *
	 * THE GRIP IS THE HANDLE AND ONLY THE GRIP, and the mirror goes in the overlay rather than
	 * at body level - both lessons from SET-55's shortcut tiles, where an `invalid` list made
	 * the most natural grab target the one dead spot and a body-level mirror landed the clone in
	 * a different stacking context from the panel it was lifted out of.
	 */
	_initDrag = function initDrag()
	{
		var $list = _list();

		// ALREADY BOUND TO THIS LIST, SO LEAVE IT ALONE. _render() runs on every change and the
		// drop handler is one of its callers - destroying the drake from inside its own drop
		// event is asking for trouble, and re-binding to the same node would be pointless work
		// four times per click. A new panel brings a new node, which is the case that rebinds.
		if (_drake && _drake.containers && _drake.containers[0] === $list[0]) {
			return;
		}

		if (_drake) {
			_drake.destroy();

			_drake = null;
		}

		if (!$list.length || typeof window.dragula !== 'function') {
			if (!$list.length) {
				return;
			}

			if (window.console && console.warn) {
				console.warn('My Settings: dragula is not loaded, so specialties cannot be reordered.');
			}

			return;
		}

		_drake = window.dragula([$list[0]], {
			moves: function moves(el, source, handle) {
				return Boolean($(handle).closest('.my-settings-specialty-grip').length);
			},
			revertOnSpill  : true,
			mirrorContainer: $list.closest('.my-settings-overlay')[0] || document.body
		});

		_drake.on('drag', function dragStarted() {
			$list.find('[data-toggle="tooltip"]').tooltip('hide');
		});

		_drake.on('dragend', function dragEnded() {
			$list.find('.tooltip').remove();
		});

		_drake.on('drop', function dropped() {
			_reorderFromDom();

			// THE ORDER IS COMMITTED BY SAVE, NOT BY THE DROP. The ticket asks for it to persist
			// immediately; on this surface that means immediately in the payload, because S26
			// gives the panel one Save in the top bar and a write on drop would be a save the
			// advisor never asked for - and one the discard guard could not undo.
			_render();
			_markDirty();
		});
	};

	/**
	 * A fresh panel, or one whose pickers changed.
	 */
	_refresh = function refresh(reseed)
	{
		if (!_list().length) {
			return;
		}

		if (reseed || !_seeded) {
			_seed();
		}

		_render();

		// THIS IS ARRIVAL, NOT A CHANGE. _render() has just written hidden inputs that did not
		// exist when the save module took its snapshot, so without this the panel is dirty
		// before the advisor has touched it - and the leave guard would claim edits nobody made.
		// Only on a fresh panel: a picker change after that is a real change.
		if (reseed && Adzuki.MySettings && Adzuki.MySettings.Save
			&& typeof Adzuki.MySettings.Save.resetEntry === 'function') {
			Adzuki.MySettings.Save.resetEntry();
		}
	};

	$(document).ready(function documentReady() {
		// SET-77: featured is a toggle with a ceiling, so the button is the only thing that
		// knows the count - a disabled one has already been ruled out by the render
		$(document).on('click', '.my-settings-overlay .my-settings-specialty-feature', function featureClicked(e) {
			var $row  = $(this).closest('.my-settings-specialty'),
			    slug  = $row.attr('data-slug'),
			    value = $row.attr('data-value');

			e.preventDefault();

			$.each(_state, function findItem(i, item) {
				if (item.slug === slug && item.value === value) {
					_state[i].featured = !item.featured;

					return false;
				}

				return true;
			});

			_render();
			_markDirty();
		});

		// REMOVING REACHES BACK UP TO THE PICKER. The list is a view of the four selects, so a
		// row removed without deselecting its option comes straight back on the next render.
		$(document).on('click', '.my-settings-overlay .my-settings-specialty-remove', function removeClicked(e) {
			var $row  = $(this).closest('.my-settings-specialty'),
			    slug  = $row.attr('data-slug'),
			    value = $row.attr('data-value');

			e.preventDefault();

			$('.my-settings-overlay .my-settings-specialty-select').each(function eachSelect() {
				var $select = $(this),
				    key     = _categoryFor($select);

				if (!key || CATEGORIES[key].slug !== slug) {
					return;
				}

				$select.find('option').filter(function isThisOne() {
					return $(this).val() === value;
				}).prop('selected', false);

				if ($.fn.selectpicker) {
					$select.selectpicker('refresh');
				}

				// the dirty tracker watches the select, and a scripted deselect fires nothing
				$select.trigger('change');
			});

			_render();
		});

		// the pickers are the other way in, and the list follows them
		$(document).on('changed.bs.select', '.my-settings-overlay .my-settings-specialty-select', function pickerChanged() {
			_render();
		});

		// a fresh panel brings new markup and new saved rows
		$(document).on('my-settings:rendered', function panelRendered() {
			_seeded = false;

			_refresh(true);
		});
	});
}(jQuery, window.Adzuki || {}));
